
import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from "@angular/core";
import { FormsModule } from "@angular/forms";

@Component({
    selector: 'tm-filter-input-selector',
    templateUrl: './filter-input-selector.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
    FormsModule
]
})
export class TmFilterInputSelectorComponent implements OnInit {
    completeList: string[] = [];

    @Input() list: string[];
    @Input() value: string;
    @Input() labelValue: string;
    @Input() placeholderValue: string;

    @Output()
    onNewOrgUpdated: EventEmitter<string> = new EventEmitter<string>();

    constructor(){}

    ngOnInit() {
        this.completeList = this.list ? [...this.list] : [];
    }

    selectValue = (value: string) => {
        this.value = value;
        this.onNewOrgUpdated.emit(value);
    }

    filterList = (query: string) => {
        if(this.list){
            this.list = this.completeList.filter(item => item.toLowerCase().includes(query.toLowerCase()));
        }
        this.value = query;
        this.onNewOrgUpdated.emit(query);
    }
}